import { queryString } from './queryString'

function coerceAction(value) {
  if (value && typeof value === 'object' && !Array.isArray(value)) return value
  if (typeof value === 'string') {
    try {
      return coerceAction(JSON.parse(value))
    } catch (err) {
      return {}
    }
  }
  return {}
}

function hasActionPayload(action) {
  const payload = coerceAction(action)
  return Boolean(payload.action || payload.configId || payload.hash || payload.hardwareId)
}

function readStoredAction() {
  try {
    return coerceAction(JSON.parse(window.localStorage.getItem('action') || ''))
  } catch (err) {
    return {}
  }
}

function writeStoredAction(action) {
  const payload = coerceAction(action)
  if (!payload.action && !payload.configId) return
  window.localStorage.setItem('action', JSON.stringify(payload))
}

function clearStoredAction() {
  window.localStorage.removeItem('action')
}

function isQuickStartPayload(action) {
  const payload = coerceAction(action)
  if (payload.action === 'goto-unit') return false
  return payload.action === 'quick-start' || Boolean(payload.configId) || Boolean(payload.hash)
}

function resolvePendingAction(queryAction) {
  const fromQuery = coerceAction(queryAction)
  if (hasActionPayload(fromQuery)) return fromQuery
  return readStoredAction()
}

function isActionDeepLink(path) {
  return (
    path === '/' ||
    path === '/quick-start' ||
    path.startsWith('/quick-start/') ||
    path === '/action' ||
    path.startsWith('/action/')
  )
}

function persistActionFromSearch(search) {
  if (!search) return
  const qs = queryString(search)
  if (qs.action) writeStoredAction(qs.action)
}

/**
 * Persist `?action=` from the navigation the loader is actually handling.
 *
 * Do not also read `window.location` here. React Router runs this loader for
 * `/home?hardwareId=` while the document URL can still be `/action/?action=…`.
 * Re-saving from that stale URL after Action cleared storage sends Home
 * straight back to `/action`, which renders nothing (black screen) until refresh.
 */
function persistIncomingAction(requestUrl) {
  if (!requestUrl) return
  try {
    const url = new URL(requestUrl, typeof window !== 'undefined' ? window.location.origin : 'http://localhost')
    if (isActionDeepLink(url.pathname)) persistActionFromSearch(url.search)
  } catch (err) {}
}

/**
 * After Cognito, `/home` must bounce to `/action` so a stored Quick Start (or
 * a goto-unit that has not been turned into `?hardwareId=` yet) can run.
 *
 * If Action already converted goto-unit into `/home?hardwareId=`, consume the
 * leftover blob instead of redirecting — that bounce is the Control Panel
 * shortcut black screen.
 */
function shouldRedirectHomeToAction(requestUrl) {
  const stored = readStoredAction()
  if (!hasActionPayload(stored)) return false
  try {
    const url = new URL(requestUrl, typeof window !== 'undefined' ? window.location.origin : 'http://localhost')
    if (stored.action === 'goto-unit' && url.searchParams.get('hardwareId')) {
      clearStoredAction()
      return false
    }
  } catch (err) {}
  return true
}

export {
  coerceAction,
  hasActionPayload,
  readStoredAction,
  writeStoredAction,
  clearStoredAction,
  isQuickStartPayload,
  resolvePendingAction,
  isActionDeepLink,
  persistIncomingAction,
  shouldRedirectHomeToAction
}
